import { Route } from '@angular/router';
import { schedules } from './schedules';
import { verification } from './verification';
import { networkAllocation } from './network-allocation';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { bookingsList } from './bookingsList';
import { mediumTransformationList } from './mediumTransformationList';
import { networkBookings } from './bookings';

export const rulesAndVerification: Route = {
  path: 'rules-and-verification',
  title: 'nav.rulesAndVerification',
  data: {
    icon: SbIcons.rules,
    breadcrumb: 'nav.rulesAndVerification',
  },
  children: [
    {
      path: '',
      redirectTo: RoutingID.schedules,
      pathMatch: 'full',
      data: {
        breadcrumb: '',
      },
    },
    schedules,
    networkAllocation,
    networkBookings,
    verification,
    bookingsList,
    mediumTransformationList,
  ],
};
